<section class="self-return-schedule">
  <h4 class="fw-bold mb-2">{{ heading() }}</h4>

  <div class="self-return-schedule__instructions wysiwyg" [innerHTML]="safeInstructions()"></div>

  <div class="row mt-4">
    <div class="col-6 col-lg-4">
      <div class="form-group form-group-xl">
        <label>{{ 'orderProcess.returnPackaging.selfReturn.dateLabel' | translate }}</label>

        <ui-delivery-datepicker
          [calendar]="calendar()"
          [disabled]="isCalendarLoading()"
          [minDate]="earliestDate()"
          [placement]="'bottom-left'"
          [ngModel]="store.date()"
          (ngModelChange)="onDateChange($event)"
          (onMonthNavigate)="onMonthNavigate($event)"
        ></ui-delivery-datepicker>
      </div>
    </div>

    <div class="col-6 col-lg-4">
      <div class="form-group form-group-xl">
        <label>{{ 'orderProcess.returnPackaging.timeLabel' | translate }}</label>

        <div class="dropdown-container dropdown-item-slim">
          <ui-dropdown
            [items]="timeOptions()"
            [placeholder]="'common.timePlaceholder' | translate"
            [ngModel]="store.time()"
            [placement]="'bottom'"
            (changeItem)="onTimeChange($event)"
          ></ui-dropdown>
        </div>
      </div>
    </div>
  </div>

  @if (isCalendarFailed()) {
    <div class="text-danger">
      {{ 'notifications.error.common.unexpectedError.message' | translate }}
    </div>
  }
</section>
